module.exports = __webpack_public_path__ + "img/invest_banner.2788a6b9.png";